/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal Authz
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccessKeyContext } from '../model';
// @ts-ignore
import { AccessKeyRequest } from '../model';
// @ts-ignore
import { Oauth2Client } from '../model';
/**
 * AuthzApi - axios parameter creator
 * @export
 */
export const AuthzApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a access key
         * @summary Creates a access key
         * @param {AccessKeyRequest} accessKeyRequest create access key request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessKey: async (accessKeyRequest: AccessKeyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessKeyRequest' is not null or undefined
            assertParamExists('createAccessKey', 'accessKeyRequest', accessKeyRequest)
            const localVarPath = `/authz/accessKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the access key
         * @summary Soft deletes the access key
         * @param {number} id the access key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessKey: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAccessKey', 'id', id)
            const localVarPath = `/authz/accessKeys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable / disable a access Key
         * @summary Enable / disable a access Key
         * @param {number} id the access key id
         * @param {boolean} enabled enabled flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableAccessKey: async (id: number, enabled: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableAccessKey', 'id', id)
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('enableAccessKey', 'enabled', enabled)
            const localVarPath = `/authz/accessKeys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the list of access keys
         * @summary Gets the list of access keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKeys: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authz/accessKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the list of available clients
         * @summary Gets the list of available clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authz/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthzApi - functional programming interface
 * @export
 */
export const AuthzApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthzApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a access key
         * @summary Creates a access key
         * @param {AccessKeyRequest} accessKeyRequest create access key request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccessKey(accessKeyRequest: AccessKeyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKeyContext>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccessKey(accessKeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes the access key
         * @summary Soft deletes the access key
         * @param {number} id the access key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccessKey(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKeyContext>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccessKey(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable / disable a access Key
         * @summary Enable / disable a access Key
         * @param {number} id the access key id
         * @param {boolean} enabled enabled flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableAccessKey(id: number, enabled: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKeyContext>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableAccessKey(id, enabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the list of access keys
         * @summary Gets the list of access keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessKeys(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessKeyContext>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the list of available clients
         * @summary Gets the list of available clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClients(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Oauth2Client>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClients(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthzApi - factory interface
 * @export
 */
export const AuthzApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthzApiFp(configuration)
    return {
        /**
         * Creates a access key
         * @summary Creates a access key
         * @param {AccessKeyRequest} accessKeyRequest create access key request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessKey(accessKeyRequest: AccessKeyRequest, options?: any): AxiosPromise<AccessKeyContext> {
            return localVarFp.createAccessKey(accessKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the access key
         * @summary Soft deletes the access key
         * @param {number} id the access key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessKey(id: number, options?: any): AxiosPromise<AccessKeyContext> {
            return localVarFp.deleteAccessKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable / disable a access Key
         * @summary Enable / disable a access Key
         * @param {number} id the access key id
         * @param {boolean} enabled enabled flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableAccessKey(id: number, enabled: boolean, options?: any): AxiosPromise<AccessKeyContext> {
            return localVarFp.enableAccessKey(id, enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the list of access keys
         * @summary Gets the list of access keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKeys(options?: any): AxiosPromise<Array<AccessKeyContext>> {
            return localVarFp.getAccessKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the list of available clients
         * @summary Gets the list of available clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients(options?: any): AxiosPromise<Array<Oauth2Client>> {
            return localVarFp.getClients(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthzApi - object-oriented interface
 * @export
 * @class AuthzApi
 * @extends {BaseAPI}
 */
export class AuthzApi extends BaseAPI {
    /**
     * Creates a access key
     * @summary Creates a access key
     * @param {AccessKeyRequest} accessKeyRequest create access key request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthzApi
     */
    public createAccessKey(accessKeyRequest: AccessKeyRequest, options?: any) {
        return AuthzApiFp(this.configuration).createAccessKey(accessKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the access key
     * @summary Soft deletes the access key
     * @param {number} id the access key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthzApi
     */
    public deleteAccessKey(id: number, options?: any) {
        return AuthzApiFp(this.configuration).deleteAccessKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable / disable a access Key
     * @summary Enable / disable a access Key
     * @param {number} id the access key id
     * @param {boolean} enabled enabled flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthzApi
     */
    public enableAccessKey(id: number, enabled: boolean, options?: any) {
        return AuthzApiFp(this.configuration).enableAccessKey(id, enabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the list of access keys
     * @summary Gets the list of access keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthzApi
     */
    public getAccessKeys(options?: any) {
        return AuthzApiFp(this.configuration).getAccessKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the list of available clients
     * @summary Gets the list of available clients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthzApi
     */
    public getClients(options?: any) {
        return AuthzApiFp(this.configuration).getClients(options).then((request) => request(this.axios, this.basePath));
    }
}
